import { IGetDetailParams } from '../types/IGetDetailParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class GetDetailRequest<TDetailResult extends IResult> extends Request<IGetDetailParams, TDetailResult> {
  constructor(method: string, id: string) {
    super(method, { id: id });
  }
}
